import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { init as initFullStory } from '@fullstory/browser';
import { AppProvider } from './context/AppContext';
import App from './App';
import 'antd/dist/antd.css';
import axios from 'axios';

// Configure axios defaults
axios.defaults.withCredentials = true;

if (window.location !== window.parent.location) {
  // Allow FullStory session capture when this app is loaded inside an iframe.
  (window as any)._fs_run_in_iframe = true;
}

initFullStory({
  orgId: 'VB5PS',
  devMode: import.meta.env.DEV,
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <AppProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AppProvider>
  </React.StrictMode>
);
